<template>
  <div :class="{'resource-main-container':!isIsef, 'resource-main-container-isef':isIsef}">
    <span v-if="fromSearch" :class="{'isefCardHeaderTitle':isIsef}">
      {{this.contentType}}
    </span>
    <span v-else>
      {{this.resourceTitle}}
    </span>
  </div>
</template>

<script>
import cardSelector from '../mixins/cardSelector'
export default {
  props: ['project', 'fromSearch'],
  mixins: [cardSelector],
  computed: {
    isIsef: function () {
      return this.$isIsef
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .resource-main-container, .resource-main-container-isef {
    color: #3e3d3d;
    font-family: $primary-font;
    font-weight: 400;
    font-size: 0.75rem;
    letter-spacing: 2.5px;
    width: 80%;
    margin: 0rem 0.75rem;
    display: flex;
    min-height: 35px;
    height: 35px;
    text-transform: uppercase;
    @include mobile {
      font-size: 0.6rem;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .resource-main-container-isef {
    height: 25px;
    min-height: 25px;
    margin-top: 0.35rem;
    margin-bottom : 0rem;
  }

  .isefCardHeaderTitle {
    font-family: 'cera-pro';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 1px;
    color: #CECECE;
    margin-left: 5px;
    padding: 14px 0;
  }

</style>
